import {MassCampaignChannelEnum} from '@/services/api-clients';
import i18n from '@/i18n/config';
import { LF } from '@/i18n/LF';


export function massCampaignChannelNameFilter(value: MassCampaignChannelEnum): string {
  switch (value) {
    case MassCampaignChannelEnum.Sms: return 'SMS';
    case MassCampaignChannelEnum.Push: return i18n.t(LF.PushNotification) as string;
  }
}
